import { FunctionComponent } from 'react';

import SatNoteForm from './Form';
import SatNoteProvider from './context';

const SatNote: FunctionComponent = () => (
  <SatNoteProvider>
    <SatNoteForm />
  </SatNoteProvider>
);
export default SatNote;
